import icon00 from './icon0-0.png'
import icon01 from './icon0-1.png'
import icon10 from './icon1-0.png'
import icon11 from './icon1-1.png'
import icon20 from './icon2-0.png'
import icon21 from './icon2-1.png'
let icon = {
    twitter: [
        icon00,
        icon01
    ],
    wechat: [
        icon10,
        icon11
    ],
    facebook: [
        icon20,
        icon21
    ]
}
export default icon